@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentOfferBlockedNoPermission {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;

  .icon {
    width: 48px;
    height: 48px;

    @include icons.ico("3d-invitation");
  }

  .title {
    font-size: 22px;

    @include texts.font("bold");
  }

  .description {
    font-size: 15px;
    color: var(--grey-text-very-very-dark);
    line-height: 1.5;
  }

  .button {
    background: var(--black);
    color: var(--white);
    font-size: 15px;
    padding: 13px 24px;
    border-radius: 50px;
    cursor: pointer;
    margin-top: 6px;

    &:hover {
      opacity: 0.8;
    }
  }
}
